import script from "./claim-page.vue?vue&type=script&lang=ts&setup=true"
export * from "./claim-page.vue?vue&type=script&lang=ts&setup=true"

import "./claim-page.vue?vue&type=style&index=0&id=b0d6f6d6&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0d6f6d6"]])

export default __exports__